export default __webpack_public_path__ + "static/media/money.85ad6273.svg";